import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpParams, HttpResponse } from '@angular/common/http';

import { BosHttpClient } from './bos-http-client';
import { ISvcSelectOption } from '@solvace/component/svc-controls';
import { BosCategoryCombo } from '../interfaces/svc-modal-bos.interface';
 
@Injectable({
  providedIn: 'root',
})
export class SvcBosCategoryService {
  constructor(private _http: BosHttpClient) {}

  public getCategoryCombo(isActive = true): Observable<ISvcSelectOption[]> {
      return this._http
        .get('/Category/BySiteId', {
          params: {
            siteId: this._http.siteId,
            isActive,
          },
        })
        .pipe(
          map((categories: BosCategoryCombo[]) => {
            return categories?.map((categorie) => ({
              text: categorie.categoryName,
              value: categorie.categoryId,
            }));
          })
        );
  }
}
